const root = 'auth'
const authentication = {
  root: root,
  login: '/',
  recoveryPassword: root + '/recuperar-senha',
  changePassword: root + '/criar-nova-senha',
}

export default authentication
